var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-0 pl-1 m-0",
      class: { "col-12": _vm.$window.isSP, "col-2": _vm.$window.isPC }
    },
    [
      _vm.$window.isSP
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn mt-2 btn-outline-dark",
                staticStyle: { float: "right" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.clickShowMenu($event)
                  }
                }
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "fa",
                    class: {
                      "fa-chevron-circle-right": !_vm.showMenu,
                      "fa-chevron-circle-left": _vm.showMenu
                    }
                  },
                  [_vm._v("メニュー")]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$window.isPC || _vm.showMenu,
                expression: "($window.isPC) || showMenu"
              }
            ],
            class: {
              accordion: _vm.$window.isSm || _vm.$window.isXs,
              open: _vm.showMenu
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("nav", [
              _c("ul", { staticClass: "nav nav-pills flex-column" }, [
                _c("li", { staticClass: "nav-item pt-2 pb-2" }, [
                  _c("h3", [_vm._v("休暇申請管理")])
                ])
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "nav nav-pills flex-column" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: {
                        active:
                          _vm.$route.path.indexOf("/admin/leave-request/top") >=
                          0
                      },
                      attrs: { href: "#" },
                      on: { click: _vm.goToLeaveRequestManage }
                    },
                    [
                      _c("i", { staticClass: "fa fa-users mr-1" }),
                      _vm._v("休暇申請一覧\n                            "),
                      _vm.unapprovedCount > 0
                        ? _c("span", { staticClass: "badge badge-danger" }, [
                            _vm._v(_vm._s(_vm.unapprovedCount))
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: {
                        active:
                          _vm.$route.path.indexOf("/admin/yukyu/management") >=
                          0
                      },
                      attrs: { href: "#" },
                      on: { click: _vm.goToYukyuManage }
                    },
                    [
                      _c("i", { staticClass: "fa fa-list mr-1" }),
                      _vm._v("有給日数管理\n                        ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: {
                        active:
                          _vm.$route.path.indexOf("/admin/yukyu/controlbook") >=
                          0
                      },
                      attrs: { href: "#" },
                      on: { click: _vm.goToYukyuControlbook }
                    },
                    [
                      _c("i", { staticClass: "fa fa-book mr-1" }),
                      _vm._v("有給管理簿\n                        ")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: {
                        active:
                          _vm.$route.path.indexOf("/admin/yukyu/sp-leave") >= 0
                      },
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/admin/yukyu/sp-leave")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-book mr-1" }),
                      _vm._v("特別休暇管理\n                        ")
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "pt-3", staticStyle: { float: "left" } }, [
      _c("h3", [_vm._v("休暇申請管理")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6770a80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6770a80","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/yukyu/YukyuMenu.vue
// module id = 479
// module chunks = 0